const BASE_URL = process.env.VUE_APP_BASE_URL;

export async function refreshAccessToken(refreshToken) {
    const response = await fetch(`${BASE_URL}auth/refresh_token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${refreshToken}`,
        },
    });

    if (!response.ok) {
        throw new Error('Token refresh failed');
    }

    return response.json(); // { jwt_token: "..." }
}
